import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

/**
 * Which Firebase project the app signs in against.
 *
 * Both modes use `pay-loom`. That is deliberate for launch and not permanent:
 * one project means one user pool, so a test signup in development creates an
 * account beside real ones, and a console action taken on a test user can reach
 * a real one. There are no live accounts yet, which is what makes it safe now
 * and is exactly the condition that stops being true after launch. Split it by
 * giving production its own project and its own FIREBASE_PROJECT_ID.
 *
 * Splitting is a migration, not a config edit: a Firebase uid is scoped to its
 * project and `User.firebaseId` in Mongo is that uid, so repointing a mode
 * orphans every account already linked in it. Cheap today, expensive later.
 *
 * The backend's FIREBASE_PROJECT_ID must name the same project, because it is
 * the audience check on every ID token. If the two disagree, every login fails.
 *
 * `authDomain` is app.payloom.in rather than pay-loom.firebaseapp.com, so the
 * Google sign-in popup shows this product's own domain and favicon instead of
 * Firebase's. It is a real dependency, not cosmetics: the OAuth client must list
 * https://app.payloom.in/__/auth/handler as an authorised redirect URI and
 * https://app.payloom.in as an authorised JavaScript origin, or every sign-in
 * fails with redirect_uri_mismatch. The firebaseapp.com entries are deliberately
 * still registered so reverting this line is a complete rollback.
 *
 * These values are not secrets. A Firebase web apiKey identifies the project to
 * Google's endpoints; it authorises nothing on its own. Access is controlled by
 * the enabled providers and the authorised-domain list, not by hiding this.
 */
const PROJECTS = {
  development: {
    apiKey: "AIzaSyBMtxS4CsW4NTeaZHSbG8UPqwa-qao2_5I",
    authDomain: "app.payloom.in",
    projectId: "pay-loom",
    storageBucket: "pay-loom.firebasestorage.app",
    messagingSenderId: "1083020220502",
    appId: "1:1083020220502:web:2f98cb43bd68d49f6103f7",
    measurementId: "G-E3T3T60ZKJ",
  },
  production: {
    apiKey: "AIzaSyBMtxS4CsW4NTeaZHSbG8UPqwa-qao2_5I",
    authDomain: "app.payloom.in",
    projectId: "pay-loom",
    storageBucket: "pay-loom.firebasestorage.app",
    messagingSenderId: "1083020220502",
    appId: "1:1083020220502:web:2f98cb43bd68d49f6103f7",
    measurementId: "G-E3T3T60ZKJ",
  },
};

// Falling back to development rather than to undefined: initializeApp with no
// config throws on import, which takes the whole bundle down at load with an
// error that names neither the mode nor the missing variable.
const firebaseConfig = PROJECTS[process.env.REACT_APP_MODE] || PROJECTS.development;

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

export { auth, provider, firebaseConfig };
